import { FC, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import './coefficient-tooltip.component.scss';

interface CoefficientTooltipProps {
  title: string;
  description: string;
  top: number;
  left: number;
}

const CoefficientTooltip: FC<CoefficientTooltipProps> = ({
  title,
  description,
  top,
  left,
}) => {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const [adjustedTop, setAdjustedTop] = useState(top);

  useEffect(() => {
    if (tooltipRef.current) {
      const tooltipHeight = tooltipRef.current.offsetHeight;
      setAdjustedTop(top - tooltipHeight - 10);
    }
  }, [top, description]);

  return ReactDOM.createPortal(
    <div
      ref={tooltipRef}
      className="tooltip-content"
      style={{
        top: `${adjustedTop}px`,
        left: `${left}px`,
        position: 'absolute',
        transform: 'translateX(-50%)',
        zIndex: 1000,
        pointerEvents: 'auto',
      }}
    >
      <strong>{title}</strong>
      <p>{description}</p>
    </div>,
    document.body, // Render in document body to avoid being clipped by parent
  );
};

export default CoefficientTooltip;
